module.exports = __webpack_public_path__ + "static/media/ballon.52ffa4ec.gif";